<template>
  <span
    v-if="count"
    v-tooltip="t('comments.unread')"
    class="inline-flex items-center align-middle ms-2 gap-1 text-warning"
    role="status"
    aria-live="polite"
    :aria-label="t('comments.unread')"
  >
    <v-icon icon="mdi-comment" size="18" color="warning" />
    <span class="text-xs font-semibold">{{ count }}</span>
  </span>
</template>

<script lang="ts" setup>
import { useI18n } from "@/composables/useI18n";

defineProps<{
  count: number;
}>();

const { t } = useI18n();
</script>
